import type { RenderNode } from "../../../util/src/layout-compiler/types.js";
import { RenderBarLoaderNode } from "./RenderBarLoaderNode.js";
import { RenderContainerNode } from "./RenderContainerNode.js";
import { RenderCustomDisciplineButtonNode } from "./RenderCustomDisciplineButtonNode.js";
import { RenderCustomDisciplineInputNode } from "./RenderCustomDisciplineInputNode.js";
import { RenderImageNode } from "./RenderImageNode.js";
import { RenderIconNode } from "./RenderIconNode.js";
import { RenderListNode } from "./RenderListNode.js";
import { RenderQrCodeNode } from "./RenderQrCodeNode.js";
import { RenderShapeNode } from "./RenderShapeNode.js";
import { RenderTextNode } from "./RenderTextNode.js";
import { RenderVideoNode } from "./RenderVideoNode.js";

type RenderNodeViewProps = {
  node: RenderNode;
  scale: number;
  isSceneRoot?: boolean;
};

export function RenderNodeView({
  node,
  scale,
  isSceneRoot = false,
}: RenderNodeViewProps) {
  if (node.style?.visibility === false) {
    return null;
  }

  switch (node.kind) {
    case "container":
      return (
        <RenderContainerNode
          node={node}
          scale={scale}
          isSceneRoot={isSceneRoot}
        />
      );

    case "layoutList":
      return <RenderListNode node={node} scale={scale} />;

    case "text":
      return <RenderTextNode node={node} scale={scale} />;

    case "shape":
      return <RenderShapeNode node={node} scale={scale} />;

    case "image":
      return <RenderImageNode node={node} scale={scale} />;

    case "video":
      return <RenderVideoNode node={node} scale={scale} />;

    case "barLoader":
      return <RenderBarLoaderNode node={node} scale={scale} />;

    case "qrCode":
      return <RenderQrCodeNode node={node} scale={scale} />;

    case "icon":
      return <RenderIconNode node={node} scale={scale} />;

    case "customDisciplineButton":
      return <RenderCustomDisciplineButtonNode node={node} scale={scale} />;

    case "customDisciplineInput":
      return <RenderCustomDisciplineInputNode node={node} scale={scale} />;

    default:
      return null;
  }
}
